import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import Leads from '../pages/leads/Leads';
import LeadDetail from '../pages/leads/LeadDetail';
import LeadForm from '../pages/leads/LeadForm';
import LeadConvert from '../pages/leads/LeadConvert';
import ProtectedRoute from '../components/auth/ProtectedRoute';

const leadRoutes = [
  // Leads list page
  <Route 
    path="leads" 
    element={
      <ProtectedRoute requiredPermission={{ resource: 'leads', action: 'read' }}>
        <Leads />
      </ProtectedRoute>
    } 
  />,
  
  // Lead create page
  <Route
    path="leads/new"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'leads', action: 'create' }}>
        <LeadForm />
      </ProtectedRoute>
    }
  />,
  
  // Lead edit page
  <Route
    path="leads/:id/edit"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'leads', action: 'update' }}>
        <LeadForm />
      </ProtectedRoute>
    }
  />,
  
  // Lead convert page
  <Route
    path="leads/:id/convert"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'leads', action: 'update' }}>
        <LeadConvert />
      </ProtectedRoute>
    }
  />,
  
  // Lead detail page
  <Route
    path="leads/:id"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'leads', action: 'read' }}>
        <LeadDetail />
      </ProtectedRoute>
    }
  />,
  
  // Redirect /leads/* to /leads if no match
  <Route path="leads/*" element={<Navigate to="/leads" replace />} />
];

export default leadRoutes;